import { Button, Card, Col, DatePicker, Divider, Flex, Form, Input, Radio, Row, Typography, message, Modal, App, Checkbox } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import credit from "../Assets/credit.svg";
import debit from "../Assets/debit.svg";
import logo from "../Assets/logo.webp";
import paypal from "../Assets/paypal.svg";
import usdt from "../Assets/usdtlogo.png";
import visaCard from "../Assets/visa.png";
import MasterCard from "../Assets/Mastercard.png";
import AmericanExpress from "../Assets/AmericanExpress.png";
import Discover from "../Assets/Discover.png";
import JCB from "../Assets/JCB.png";
import DinersClub from "../Assets/DinersClub.png";
import UnionPay from "../Assets/UnionPay.png";
import stripe from "../Assets/stripe.png";
import PopgridBook from "../Assets/pipgrid-book.png";
import whatsappimg from "../Assets/whatsapp_PNG95162-300x252.webp";
import { handleWhatsAppClick } from "../commonFunction";
import ContactInput from "../Components/ContactInput";
import { ERROR_MESSAGE } from "../const";
import AxiosService from "../services/APIService";
import { RiDeleteBin6Line } from "react-icons/ri";
// import { WhatsAppOutlined, MailOutlined } from "@ant-design/icons";
// import plus from "../Assets/unnamed-file.webp";
// import { LocalStorageService } from "../services/LocalStorage";
// import ultimateMaster from "../Assets/ultimate_Master.webp";
// import ultimatePower from "../Assets/ultimate_Power.webp";
// import ultimateFortune from "../Assets/ultimate_Fortune.webp";
// import TRC from "../Assets/TRC.png";

const { Paragraph } = Typography;

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="8.5" stroke="white" />
    <path d="M5.5 9L7.5 11L12.5 6" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

function UserRegistration() {
  const [form] = Form.useForm();
  const paymentMethod = Form.useWatch("paymentMethod", form);
  const { message: msg } = App.useApp();
  const location = useLocation();
  const apiService = new AxiosService();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [promoLoading, setPromoLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get("refferalCode");
  const [promoCode, setPromoCode] = useState("");
  const [clickApply, setClickApply] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [toggle, setToggle] = useState(0);
  const [discountData, setDiscountData] = useState({
    promoCode: null,
    refferalCode: null,
    affiliateCode: null,
  });

  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  const [allPlans, setAllPlans] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [isExistingUser, setIsExistingUser] = useState(false);

  const openPlanModal = () => {
    setIsPlanModalOpen(true);
  };
  // const navigate = useNavigate();
  // const [applyPromoCode, setApplyPromoCode] = useState(false);

  const promoCodeFromUrl = searchParams.get("promoCode");
  useEffect(() => {
    getAllPlans();
  }, []);

  useEffect(() => {
    // const searchParams = new URLSearchParams(location.search);
    // const planId = searchParams.get("planId");
    const affiliateCode = searchParams.get("affiliateCode");
    const refferalCode = searchParams.get("refferalCode");
    if (affiliateCode || refferalCode || promoCode) {
      setDiscountData({
        affiliateCode: affiliateCode || null,
        refferalCode: refferalCode || null,
        promoCode: promoCode || null,
      });
    }
  }, [location.search]);

  useEffect(() => {
    if (promoCodeFromUrl) {
      setPromoCode(promoCodeFromUrl);
      // setApplyPromoCode(true);
      setClickApply(true);
      handleApplyPromoCode(promoCodeFromUrl);
    }
  }, [promoCodeFromUrl]);

  useEffect(() => {
    const userId = searchParams.get("userId");
    if (userId) {
      setIsExistingUser(true);
      fetchUserData();
    } else {
      setIsExistingUser(false);
    }
  }, [searchParams]);

  const fetchUserData = async () => {
    try {
      const res = await apiService.get("/auth/me");
      if (res && res.user) {
        const user = res.user;
        form.setFieldsValue({
          fullname: user.fullName,
          email: user.email,
          phoneNo: user.phoneNumber,
          city: user.city,
          state: user.state,
          country: user.country,
          dob: user.dob ? dayjs(user.dob) : null,
        });
      }
    } catch (error) {
      console.error("Error fetching user data for prefill:", error);
    }
  };
  useEffect(() => {
    if (selectedProduct?.name) {
      const accountsCount = selectedProduct?.name === "PG Platinum" ? 2 : 1;
      form.setFieldsValue({
        accountDetails: Array.from({ length: accountsCount }).map(() => ({
          accountName: "",
          accountNumber: "",
          balance: "",
          brokerName: "",
          brokerServer: "",
          investorPassword: "",
        })),
      });
    }
  }, [selectedProduct]);

  const getAllPlans = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/plan/all`);
      if (!res?.data?.success) {
        msg.error(res?.data?.message || "Failed to fetch plans");
        return;
      }
      const plans = res.data.data;
      if (!plans || plans.length === 0) return;
      setAllPlans(plans);

      const paramPlanId = searchParams.get("planId");
      let selectedPlan = plans.find((p) => p._id === paramPlanId);
      if (!selectedPlan) {
        selectedPlan = plans[0];
        if (paramPlanId) {
          msg.warning("Invalid plan, loaded default plan.");
        }
      }
      setSelectedProduct(selectedPlan);
      // Initialize cart with the selected plan
      setCartItems([{ ...selectedPlan, quantity: 1 }]);
    } catch (error) {
      console.error("Error fetching plans:", error);
      msg.error("Failed to load plans");
    }
  };

  const increaseQuantity = (planId) => {
    setCartItems(prev => prev.map(item =>
      item._id === planId ? { ...item, quantity: item.quantity + 1 } : item
    ));
  };

  const decreaseQuantity = (planId) => {
    setCartItems(prev => prev.map(item =>
      item._id === planId && item.quantity > 1 ? { ...item, quantity: item.quantity - 1 } : item
    ));
  };

  const removeCartItem = (planId) => {
    setCartItems((prev) => prev.filter((item) => item._id !== planId));
  };

  const handleAddToCart = (plan) => {
    setCartItems(prev => {
      const existing = prev.find(item => item._id === plan._id);
      if (existing) {
        return prev.map(item => item._id === plan._id ? { ...item, quantity: item.quantity + 1 } : item);
      }
      return [...prev, { ...plan, quantity: 1 }];
    });
    setIsPlanModalOpen(false);
  };

  const getTotalPrice = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const getPriceAfterPromo = () => {
    const total = getTotalPrice();
    if (clickApply && discountType) {
      if (discountType === "percentage") {
        return total - (total * discount) / 100;
      } else {
        return total - discount;
      }
    }
    return total;
  };

  const getTotalAccountCount = () => {
    return cartItems.reduce((total, item) => {
      const accountsPerPlan = item.name === "PG Platinum" ? 2 : 1;
      return total + (item.quantity * accountsPerPlan);
    }, 0);
  };

  const handleApplyPromoCode = async (code = promoCode) => {
    setPromoLoading(true);
    try {
      const res = await apiService.post("/promocode/validate", { code });
      if (!res?.success) {
        setClickApply(false);
        msg.error(res?.message || "Invalid promo code");
        return;
      }
      msg.success("Promo code applied successfully");
      setClickApply(true);
      const response = await apiService.get(`/promocode/details/${code}`);
      if (!response?.success) return;
      const { discountType, discountAmount } = response.payload;
      setDiscountType(discountType);
      setDiscount(discountAmount);
    } catch (error) {
      setClickApply(false);
      msg.error("Invaid Promocode");
    } finally {
      setPromoLoading(false);
    }
  };

  const formSubmit = async (val) => {
    if (cartItems.length === 0) {
      msg.error("Please add plan first");
      return;
    }
    const accountCount = getTotalAccountCount(); // Number of MT5 accounts to process

    for (let i = 1; i <= accountCount; i++) {
      const accountFields = [`accountName${i}`, `accountNumber${i}`, `balance${i}`, `brokerName${i}`, `brokerServer${i}`, `investorPassword${i}`];
      const anyFilled = accountFields.some((field) => {
        const value = val?.[field] || val?.[`${field} `];
        return value && value.trim() !== "";
      });
      const anyEmpty = accountFields.some((field) => {
        const value = val?.[field] || val?.[`${field} `] || "";
        return value.trim() === "";
      });
      if (anyFilled && anyEmpty) {
        msg.error(`Please fill all details for Account ${i} or leave all fields empty.`);
        return;
      }
    }

    const planNames = cartItems.reduce((acc, item) => {
      const count = item.name === "PG Platinum" ? 2 : 1;
      return acc.concat(Array(item.quantity * count).fill(item.name));
    }, []);

    const accountDetails = [];

    for (let i = 1; i <= accountCount; i++) {
      const getValue = (key) => {
        const value = val?.[key] || val?.[`${key} `];
        return value ? value.trim() : "";
      };

      const account = {
        accountName: getValue(`accountName${i}`),
        accountNumber: getValue(`accountNumber${i}`),
        balance: getValue(`balance${i}`),
        brokerName: getValue(`brokerName${i}`),
        brokerServer: getValue(`brokerServer${i}`),
        investorPassword: getValue(`investorPassword${i}`),
        productName: planNames[i - 1] || "",
      };

      // Only add the account if all required fields are present
      const requiredFields = ["accountName", "accountNumber", "brokerName", "brokerServer", "investorPassword", "productName"];
      const hasAllRequiredFields = requiredFields.every((field) => account[field] && account[field].trim() !== "");

      if (hasAllRequiredFields) {
        accountDetails.push(account);
      }
    }

    const payload = {
      fullName: val?.fullname?.trim() || "",
      email: val?.email?.trim() || "",
      password: val?.password?.trim() || "",
      phoneNumber: val?.phoneNo?.trim() || "",
      dob: val?.dob ? dayjs(val.dob).format("YYYY-MM-DD") : "",
      productName: cartItems.map((item) => item.name).join(", "),
      paidAmount: (paymentMethod === "USDT" ? getPriceAfterPromo() * 0.9 : getPriceAfterPromo()).toFixed(2),
      usdtDiscount: (paymentMethod === "USDT" ? getPriceAfterPromo() * 0.1 : 0).toFixed(2),
      city: val?.city?.trim() || "",
      state: val?.state?.trim() || "",
      country: val?.country?.trim() || "",
      // paymentMethod: val?.paymentMethod || "",
      accountDetails: accountDetails, // Always include accountDetails, even if empty array
      ...(referralCode && { refferedCode: referralCode }),
      ...(discountData?.affiliateCode && { affiliateCode: discountData.affiliateCode }),
      ...(discountData?.promoCode && { promoCode: discountData.promoCode }),
    };

    setLoading(true);
    try {
      let finalUserId = searchParams.get("userId");

      if (!finalUserId) {
        const response = await apiService.post("/auth/register", payload);
        if (response) {
          finalUserId = response.user._id;
          msg.success("Registration successful!");
        } else {
          setLoading(false);
          return;
        }
      }

      if (finalUserId) {
        const checkoutPayload = {
          userId: finalUserId,
          amount: (paymentMethod === "USDT" ? getPriceAfterPromo() * 0.9 : getPriceAfterPromo()).toFixed(2),
          usdtDiscount: (paymentMethod === "USDT" ? getPriceAfterPromo() * 0.1 : 0).toFixed(2),
          items: cartItems.map((item) => ({
            planId: item._id,
            quantity: item.quantity
          })),
          ...(discountData?.affiliateCode && {
            affiliateCode: discountData.affiliateCode,
          }),
          ...(discountData?.refferalCode && {
            refferalCode: discountData.refferalCode,
          }),
          ...(discountData?.promoCode?.trim() || promoCode?.trim() ? { promoCode: discountData?.promoCode || promoCode } : {}),
        };

        if (val.paymentMethod === "UPI") {
          const checkoutRes = await apiService.post("/payment/create-checkout", checkoutPayload);
          if (checkoutRes?.success) {
            setLoading(true);
            window.open(checkoutRes.payload.checkoutUrl, "_self");
            form.resetFields();
            setClickApply(false);
            // setApplyPromoCode(false);
            setDiscount(null);
            setDiscountType(null);
          } else {
            setLoading(false);
            message.error(checkoutRes?.message || "Checkout failed");
          }
        } else if (val.paymentMethod === "stripe") {
          const checkoutRes = await apiService.post("/payment/create-checkout-stripe", checkoutPayload);
          if (checkoutRes?.success) {
            setLoading(true);
            window.open(checkoutRes.payload.checkoutUrl, "_self");
            form.resetFields();
            setClickApply(false);
            setDiscount(null);
            setDiscountType(null);
          } else {
            setLoading(false);
            message.error(checkoutRes?.message || "Checkout failed");
          }
        } else {
          const checkoutRes = await apiService.post("/payment/create-checkout/crejis", checkoutPayload);

          if (checkoutRes?.data?.msg === "ok") {
            setLoading(true);
            window.open(checkoutRes?.data?.data?.checkout_url, "_self");
            form.resetFields();
            setClickApply(false);
            setDiscount(null);
            setDiscountType(null);
          } else {
            setLoading(false);
            msg.error(checkoutRes?.message || "Checkout failed");
          }
        }
      }
    } catch (error) {
      msg.error(ERROR_MESSAGE[error?.message] || error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleFinishFailed = () => {
    if (cartItems.length === 0) {
      msg.error("Please add plan first");
    }
  };

  return (
    <div className="register-wrapper">
      <div className="form-parent">
        {/* <Row justify="center" style={{ width: "100%", marginBottom: 30 }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img src={logo} style={{ width: 300, maxWidth: "100%" }} alt="Logo" />
            </div>
          </Col>
        </Row> */}

        <Form form={form} layout="vertical" className="center-regsiter-form" onFinish={formSubmit} onFinishFailed={handleFinishFailed} autoComplete="off">
          <Row gutter={[30, 30]} justify="center">
            {/* Left Form Column */}
            <Col xs={24} sm={24} md={24} lg={14} xl={14}>
              <Card className="registration-card" title="Pip Grid Registration">
                <Row gutter={16}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                      // label="Full Name"
                      name="fullname"
                      rules={[{ required: true, message: "Please Enter full name!" }]}
                    >
                      <Input placeholder="Enter Full Name" disabled={isExistingUser} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} className="contact">
                    <ContactInput
                      form={form}
                      name="phoneNo"
                      // label="Phone No."
                      require={true}
                      disabled={isExistingUser}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                      // label="Email Address (User)"
                      name="email"
                      rules={[
                        {
                          required: true,
                          type: "email",
                          message: "Please Enter valid email address!",
                        },
                      ]}
                    >
                      <Input placeholder="Enter Email" disabled={isExistingUser} />
                    </Form.Item>
                  </Col>
                  {!isExistingUser && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item
                        autoComplet={false}
                        // label="Password (User)"
                        name="password"
                        rules={[{ required: true, message: "Please Enter password!" }]}
                      >
                        <Input.Password autoComplete="nope" placeholder="Enter Password" />
                      </Form.Item>
                    </Col>
                  )}
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item

                      name="dob"
                      rules={[
                        {
                          required: true,
                          message: "Please select date of birth!",
                        },
                      ]}
                    >
                      <DatePicker placeholder="Date of Birth" style={{ width: "100%" }} format="DD-MM-YYYY" disabled={isExistingUser} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                      // label="City"
                      name={"city"}
                      rules={[{ required: true, message: "Please Enter City!" }]}
                    >
                      <Input placeholder="City" disabled={isExistingUser} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                      // label="State"
                      name={"state"}
                      rules={[{ required: true, message: "Please Enter State!" }]}
                    >
                      <Input placeholder="State" disabled={isExistingUser} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                      // label="Country"
                      name={"country"}
                      rules={[{ required: true, message: "Please Enter Country!" }]}
                    >
                      <Input placeholder="Country" disabled={isExistingUser} />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Typography.Text style={{ color: "#fff", fontSize: "14px", marginBottom: "15px", display: "block", opacity: 0.8 }}>
                      If your Trading account is not ready yet, you can update it later on user portal.
                    </Typography.Text>
                  </Col>

                  {cartItems.reduce((acc, item) => {
                    const count = item.name === "PG Platinum" ? 2 : 1;
                    const totalAccounts = item.quantity * count;
                    for (let i = 1; i <= totalAccounts; i++) {
                      acc.push({ name: item.name, planIndex: i });
                    }
                    return acc;
                  }, []).map((itemData, index) => {
                    const { name: planName, planIndex } = itemData;
                    return (
                      <React.Fragment key={index}>
                        <Col span={24} className="card-flex">
                          <Typography.Title
                            level={4}
                            style={{
                              color: "#fff",
                              fontWeight: 700,
                              // marginBottom: "0",
                            }}
                            ref={(el) => {
                              if (el) {
                                el.style.setProperty("margin-bottom", "0", "important");
                              }
                            }}

                          >
                            ( {planName} ) Mt5 Account Details - {planIndex} &nbsp;
                          </Typography.Title>
                          <div
                            className={`downArrow ${toggle === index ? "rotate" : ""}`}
                            onClick={() => setToggle(toggle === index ? null : index)}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                              <path d="M297.4 470.6C309.9 483.1 330.2 483.1 342.7 470.6L534.7 278.6C547.2 266.1 547.2 245.8 534.7 233.3C522.2 220.8 501.9 220.8 489.4 233.3L320 402.7L150.6 233.4C138.1 220.9 117.8 220.9 105.3 233.4C92.8 245.9 92.8 266.2 105.3 278.7L297.3 470.7z" />
                            </svg>
                          </div>
                        </Col>
                        <div className={`animation-time ${toggle === index ? "show" : "hide"}`}>
                          <Row style={{ paddingTop: "20px" }}>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ padding: '0 8px' }}>
                              <Form.Item
                                autoComplete="off"
                                name={`accountName${index + 1} `}
                                style={{ marginBottom: 4 }}
                              >
                                <Input placeholder="Enter Account Name" autoComplete="nope" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ padding: '0 8px' }}>
                              <Form.Item
                                name={`accountNumber${index + 1} `}
                              >
                                <Input type="number" placeholder="Enter Account Number" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ padding: '0 8px' }}>
                              <Form.Item
                                name={`balance${index + 1} `}
                              >
                                <Input type="number" placeholder="Enter Balance" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ padding: '0 8px' }}>
                              <Form.Item
                                name={`brokerName${index + 1} `}
                              >
                                <Input placeholder="Enter Broker Name" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ padding: '0 8px' }}>
                              <Form.Item
                                name={`investorPassword${index + 1} `}
                              >
                                <Input.Password placeholder="Enter Inverstor Password" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ padding: '0 8px' }}>
                              <Form.Item
                                name={`brokerServer${index + 1} `}
                              >
                                <Input placeholder="Enter Broker Server" />
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Typography style={{ color: "#fff" }}>
                                The bot file will be created based on the entered balance amount here. To ensure optimal performance, please enter the
                                correct amount and maintain the mentioned balance.
                              </Typography>
                            </Col>
                          </Row>
                        </div>
                        <Divider style={{ margin: "10px 2px" }} />
                      </React.Fragment>
                    );
                  })}
                </Row>
                <div>
                  <h3 className="disclaimer-text">DISCLAIMER</h3>
                  <Paragraph
                    ellipsis={{
                      rows: 4,
                      expandable: true,
                      symbol: "Expand",
                    }}
                    style={{ color: "white", fontSize: "14px", fontFamily: "GeneralSans-Regular" }}
                  >
                    Pip Grid is an advanced automated trading solution designed to enhance trading efficiency, but it is essential to understand the
                    risks associated with Forex trading. The Forex market involves substantial risk, and even experienced traders may face significant
                    losses. Studies indicate that 85%–95% of manual traders lose their entire capital. Whether trading manually or using an automated
                    system, a thorough understanding of market risks is crucial.
                    <br />
                    While Pip Grid is built to optimize trading strategies, it does not eliminate the inherent risks of Forex trading. Market
                    volatility, execution delays, liquidity fluctuations, and technical failures can lead to unexpected losses. Although our system
                    employs risk management strategies, there are no guarantees of consistent profits, and traders must acknowledge the possibility of
                    losing their entire investment.
                    <br />
                    By using Pip Grid, you accept that trades are executed automatically based on pre-set parameters, which may become less effective
                    due to unpredictable market changes. Risk management settings, including stop-loss limits, must be configured according to your
                    financial goals and risk tolerance. The platform does not provide personalized financial advice, and all trading decisions are
                    made at your own discretion and risk. Additionally, market disruptions, broker-related issues, or technical failures may impact
                    the bot's performance, and the platform is not liable for any resulting financial losses.
                    <br />
                    Forex trading may not be suitable for all investors. Only trade with funds you can afford to lose, and seek independent financial
                    advice if you are uncertain about engaging in automated trading. Past performance does not guarantee future results. By using Pip
                    Grid, you fully accept the risks and take full responsibility for your trading outcomes.
                    <br />
                  </Paragraph>
                </div>
              </Card>
            </Col>

            {/* Right Summary Column */}
            <Col xs={24} sm={24} md={24} lg={10} xl={10}>
              <Card className="bookDetail">
                <div className="product-card-image">
                  <img src={PopgridBook} alt="Product Logo" />
                </div>
                <Row align="middle" gutter={[0, 10]}>
                  <Col span={15} className="order-text">
                    Order Summary
                  </Col>
                  <Col span={9} className="order-text right-text">
                    Sub Total
                  </Col>
                  {/* Map over cart items */}
                  {cartItems.map((item, idx) => (
                    <React.Fragment key={item._id}>
                      <Col span={6} className="title" style={{ textAlign: "left" }}>
                        <span className="span-text">{item.name}</span>
                      </Col>
                      <Col span={7} className="title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingRight: "10px" }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          borderRadius: '4px',
                          overflow: 'hidden',
                          height: '32px',
                        }}>
                          <Button
                            type="text"
                            onClick={() => decreaseQuantity(item._id)}
                            style={{
                              width: '24px',
                              height: '24px',
                              padding: 0,
                              background: '#fff',
                              display: 'flex',
                              fontSize: '14px',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: item.quantity > 1 ? 'pointer' : 'not-allowed',
                              opacity: item.quantity > 1 ? 1 : 0.5,
                              borderRadius: '4px'
                            }}
                            disabled={item.quantity <= 1}
                          >
                            -
                          </Button>
                          <div style={{
                            width: '40px',
                            height: '24px',
                            padding: 0,
                            borderRadius: '4px',
                            border: '1px solid #353535',
                            background: 'transparent',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 5px',
                            color: '#fff',
                            fontSize: '12px',
                            fontWeight: 400
                          }}>
                            {item.quantity}
                          </div>
                          <Button
                            type="text"
                            onClick={() => increaseQuantity(item._id)}
                            style={{
                              width: '24px',
                              height: '24px',
                              padding: 0,
                              fontSize: '14px',
                              background: '#fff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                              borderRadius: '4px'
                            }}
                          >
                            +
                          </Button>
                        </div>
                      </Col>
                      <Col span={2} style={{ textAlign: "right", display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <Button
                          type="text"
                          icon={<RiDeleteBin6Line />}
                          onClick={() => removeCartItem(item._id)}
                          style={{
                            color: '#ff4d4f',
                            padding: 0,
                            fontSize: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        />
                      </Col>
                      <Col span={9} className="value" style={{ textAlign: "right" }}>
                        ${(item.price * item.quantity).toFixed(2)}
                      </Col>

                    </React.Fragment>
                  ))}
                  <Col span={24} style={{ textAlign: 'right', marginBottom: '5px' }}>
                    <Button
                      onClick={openPlanModal}
                      style={{
                        background: "linear-gradient(90deg, #B120FF 0%, #4F46E5 100%)",
                        color: "#fff",
                        border: "none",
                        fontWeight: 600
                      }}
                    >
                      Add Plan
                    </Button>
                  </Col>
                  <Col span={14} className="title" style={{ textAlign: "left" }}>
                    Sub Total
                  </Col>

                  <Col span={10} className="value" style={{ textAlign: "right" }}>
                    ${getTotalPrice().toFixed(2)}
                  </Col>
                  {/* {applyPromoCode ? (
                    <> */}
                  {!clickApply ? (
                    <>
                      <div className="input-button-grid">
                        <Input
                          placeholder="Enter PromoCode"
                          size="small"
                          value={promoCode}
                          onChange={(e) => setPromoCode(e.target.value)}
                          onPressEnter={(e) => {
                            e.preventDefault();
                            handleApplyPromoCode(promoCode);
                          }}
                        />

                        <Button
                          onClick={(e) => {
                            e.preventDefault();
                            handleApplyPromoCode(promoCode);
                          }}
                          className="apply-now-btn"
                          htmlType="button"
                          loading={promoLoading}
                        >
                          Apply Now
                        </Button>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* Row 1 */}
                      <Col span={20} className="title" style={{ textAlign: "left" }}>
                        Promocode Discount <button
                          onClick={() => {
                            setClickApply(false);
                            setPromoCode("");
                            setDiscount(0);
                            setDiscountType(null);
                          }}
                          style={{
                            background: "transparent",
                            border: "1px solid #F56565",
                            color: "#F56565",
                            borderRadius: "20px",
                            padding: "4px 14px",
                            fontSize: "12px",
                            cursor: "pointer",
                            marginLeft: "10px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            transition: "all 0.2s ease",
                          }}
                        >
                          ✕
                        </button>
                      </Col>

                      <Col span={4} className="value" style={{ textAlign: "right" }}>
                        -$
                        {discountType === "percentage"
                          ? (discount * getTotalPrice()) / 100
                          : discount}
                      </Col>

                      {/* Row 2 – Right-aligned Remove button */}
                      {/* <Col span={24} style={{ marginTop: "8px", textAlign: "left" }}>
                        <button
                          onClick={() => {
                            setClickApply(false);
                            setPromoCode("");
                            setDiscount(0);
                            setDiscountType(null);
                          }}
                          style={{
                            background: "transparent",
                            border: "1px solid #F56565",
                            color: "#F56565",
                            borderRadius: "20px",
                            padding: "4px 14px",
                            fontSize: "12px",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            transition: "all 0.2s ease",
                          }}
                        >
                          ✕ Remove
                        </button>
                      </Col> */}
                    </>
                  )}

                  {paymentMethod === "USDT" && (
                    <>
                      <Col span={20} className="title" style={{ textAlign: "left" }}>
                        USDT Discount (10%)
                      </Col>
                      <Col span={4} className="value" style={{ textAlign: "right" }}>
                        -${(getPriceAfterPromo() * 0.1).toFixed(2)}
                      </Col>
                    </>
                  )}
                  {/* </>
                  ) : (
                    <>
                      <Col
                        span={14}
                        className="title"
                        style={{ textAlign: "left" }}
                      >
                        <Input
                          style={{ lineHeight: 2 }}
                          placeholder="Enter PromoCode"
                          size="small"
                          value={promoCode}
                          onChange={(e) => setPromoCode(e.target.value)}
                          onPressEnter={(e) => {
                            e.preventDefault();
                            handleApplyPromoCode(promoCode);
                          }}
                        />
                      </Col>
                      <Col
                        span={10}
                        className="value"
                        style={{ textAlign: "right" }}
                      >
                        <Button
                          onClick={(e) => {
                            e.preventDefault();
                            handleApplyPromoCode(promoCode);
                          }}
                          type="primary"
                          htmlType="button"
                          loading={loading}
                          style={{ backgroundColor: "#FEF250" }}
                        >
                          Apply
                        </Button>
                      </Col>
                    </>
                  )} */}

                  <div>
                    <svg width="348" height="1" viewBox="0 0 348 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0.5L348 0.49997" stroke="url(#paint0_linear_539_3081)" />
                      <defs>
                        <linearGradient id="paint0_linear_539_3081" x1="4.37114e-08" y1="1" x2="348" y2="0.99997" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#B120FF" stop-opacity="0" />
                          <stop offset="0.5" stop-color="#B120FF" />
                          <stop offset="1" stop-color="#B120FF" stop-opacity="0" />
                        </linearGradient>
                      </defs>
                    </svg>

                  </div>
                  <Col span={14} className="total">
                    Total
                  </Col>
                  <Col span={10} className="total" style={{ textAlign: "right" }}>
                    ${(paymentMethod === "USDT" ? getPriceAfterPromo() * 0.9 : getPriceAfterPromo()).toFixed(2)}
                  </Col>
                </Row>
              </Card>
              <Card style={{ marginTop: "16px" }} className="rightBottomCard">

                {/* PAYMENT ROW ONLY */}
                <div style={{ display: "flex", width: "100%", }}>

                  {/* LEFT COLUMN */}
                  {/* <div
                    style={{
                      width: "80%",
                      borderRight: "1px solid rgba(153, 153, 153, 0.2)",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Form.Item
                      name="paymentMethod"
                      rules={[
                        { required: true, message: "Please select a payment method" },
                      ]}
                      style={{ marginBottom: 10 }}
                      className="radio-form-item"
                    >
                      <Radio.Group style={{ color: "#fff", fontSize: "18px" }}>
                        <Radio value="UPI" style={{ fontSize: "18px", color: "#fff" }}>
                          <span style={{ fontSize: '12px', lineHeight: '1', whiteSpace: 'nowrap', fontFamily: "GeneralSans-Regular" }}>Pay Using Credit/Debit Card or PayPal</span>
                        </Radio>
                      </Radio.Group>
                    </Form.Item>

                    <Flex gap={20} style={{ paddingLeft: 0, paddingBottom: 10 }}>
                      <img src={debit} style={{ width: "35px", height: "35px" }} />
                      <img src={paypal} style={{ width: "35px", height: "35px" }} />
                      <img src={credit} style={{ width: "35px", height: "35px" }} />
                    </Flex>
                  </div> */}
                  <div style={{ width: '50%' }}>
                    <div
                    >
                      <Form.Item
                        name="paymentMethod"
                        rules={[
                          { required: true, message: "Please select a payment method" },
                        ]}
                        className="radio-form-item"
                      >
                        <Radio.Group style={{ color: "#fff", fontSize: "18px" }} className="custom-radio">
                          <Radio value="stripe" style={{ fontSize: "18px", color: "#fff" }}>
                            <span style={{ fontSize: '12px', lineHeight: '1', whiteSpace: 'nowrap' }}>Pay With Stripe</span>
                          </Radio>
                        </Radio.Group>
                      </Form.Item>

                      <Flex gap={20} style={{ paddingLeft: 0, paddingBottom: 10 }}>
                        <img src={stripe} style={{ width: "60px", height: "50px" }} />
                      </Flex>
                      <div className="payment-icons-grid">
                        <img src={visaCard} style={{ width: "40px", height: "20px", objectFit: "contain", background: "#fff", padding: "4px", borderRadius: "4px", border: "1px solid rgba(255,255,255,0.1)" }} alt="Visa" />
                        <img src={MasterCard} style={{ width: "40px", height: "20px", objectFit: "contain", background: "#000", padding: "4px", borderRadius: "4px", border: "1px solid rgba(255,255,255,0.1)" }} alt="Mastercard" />
                        <img src={AmericanExpress} style={{ width: "40px", height: "20px", objectFit: "contain", background: "#007bc1", padding: "4px", borderRadius: "4px", border: "1px solid rgba(255,255,255,0.1)" }} alt="Amex" />
                        <img src={Discover} style={{ width: "40px", height: "20px", objectFit: "contain", background: "#fff", padding: "4px", borderRadius: "4px", border: "1px solid rgba(255,255,255,0.1)" }} alt="Discover" />
                        <img src={DinersClub} style={{ width: "40px", height: "20px", objectFit: "contain", background: "#fff", padding: "4px", borderRadius: "4px", border: "1px solid rgba(255,255,255,0.1)" }} alt="Discover" />
                        <img src={JCB} style={{ width: "40px", height: "20px", objectFit: "contain", background: "#fff", padding: "4px", borderRadius: "4px", border: "1px solid rgba(255,255,255,0.1)" }} alt="JCB" />
                        <img src={UnionPay} style={{ width: "40px", height: "20px", objectFit: "contain", background: "#fff", padding: "4px", borderRadius: "4px", border: "1px solid rgba(255,255,255,0.1)" }} alt="UnionPay" />
                      </div>
                    </div>
                  </div>

                  {/* RIGHT COLUMN */}
                  <div style={{ width: "50%", }}>
                    <Form.Item name="paymentMethod" style={{ marginBottom: 4 }} className="radio-form-item">
                      <Radio.Group style={{ color: "#fff", fontSize: "18px" }} className="custom-radio">
                        <Radio value="USDT" style={{ fontSize: "18px", color: "#fff" }}>
                          <span style={{ fontSize: '12px', lineHeight: '1', whiteSpace: 'nowrap' }}>USDT (10% OFF)</span>
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                    <Flex gap={20} style={{ paddingLeft: 0, paddingBottom: 10 }}>
                      <img src={usdt} style={{ width: "35px", height: "35px" }} />
                    </Flex>

                  </div>

                </div>

                <div style={{ marginBottom: '15px' }}>
                  <Checkbox
                    checked={isTermsAccepted}
                    onChange={(e) => setIsTermsAccepted(e.target.checked)}
                    style={{ color: '#fff' }}
                  >
                    I agree to the <a href="https://pipgrid.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer">
                      <span style={{ color: '#B120FF', textDecoration: 'underline' }}>Terms & Conditions</span>
                    </a>
                  </Checkbox>
                </div>
                <div>
                  <Button
                    style={{ width: '100%' }}
                    // type="primary"
                    htmlType="submit"
                    loading={loading}
                    disabled={!isTermsAccepted}
                    className="place-order spacing-remoove"
                  >
                    Place Order
                  </Button>
                </div>
                {/* DESCRIPTION */}
                <Typography style={{ padding: "0", color: "#ffffffcc" }}>
                  Your personal data will be used to process your order, support your
                  experience throughout this website, and for other purposes described in
                  our privacy policy.
                </Typography>
              </Card>



              {/* <div style={{ marginTop: "20px" }}>
                <Typography
                  style={{ fontSize: "18px", color: "#fff", fontWeight: 300 }}
                >
                  For Support, Contact us at
                </Typography>
                <Row gutter={16} style={{ marginTop: "4px" }}>
                  <Col xs={24} sm={12} md={12} lg={24} xl={12}>
                    <Space align="center">
                      <WhatsAppOutlined
                        style={{
                          fontSize: "18px",
                          color: "#FEF250",
                          lineHeight: 1,
                        }}
                      />
                      <Typography
                        style={{
                          color: "white",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                        onClick={handleWhatsAppClick}
                      >
                        +971 0525218176
                      </Typography>
                    </Space>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={24} xl={12}>
                    <Space align="center">
                      <MailOutlined
                        style={{
                          fontSize: "18px",
                          color: "#FEF250",
                          lineHeight: 1,
                        }}
                      />
                      <Typography
                        style={{
                          color: "white",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                        onClick={handleEmailClick}
                      >
                        support@pipgrid.com
                      </Typography>
                    </Space>
                  </Col>
                </Row>
              </div> */}
            </Col>
          </Row>
        </Form>
      </div>
      <div className="whatsapp">
        <img src={whatsappimg} style={{ cursor: "pointer" }} onClick={handleWhatsAppClick} />
      </div>

      <Modal
        title={null}
        footer={null}
        open={isPlanModalOpen}
        onCancel={() => setIsPlanModalOpen(false)}
        width={1200}
        centered
        styles={{ content: { padding: 0, background: 'transparent' } }}
        modalRender={(modal) => (
          <div style={{ background: 'transparent' }}>
            {modal}
          </div>
        )}
      >
        <div className="prizingSectionAlignment" id="pricing" style={{
          padding: '10px 40px',
          backgroundColor: '#070707',
          borderRadius: '20px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 20px 50px rgba(0,0,0,0.5)'
        }}>
          <div className="container-xs">
            <div className="sectionTitle" style={{ padding: 0 }}>
              <h2 style={{ margin: '0 auto 10px auto' }}>Discover Products With the Best Pricing</h2>
            </div>

            <div className="grid">
              {allPlans.map((plan, index) => {
                const mainFeatures = plan?.features?.slice(0, -2) || [];
                const referFeatures = plan?.features?.slice(-2) || [];
                // Calculate quantity of this plan in cart
                const cartItem = cartItems.find(item => item._id === plan._id);
                const quantityInCart = cartItem ? cartItem.quantity : 0;

                return (
                  <div key={index} className="griditems">
                    {quantityInCart > 0 && (
                      <div style={{
                        position: 'absolute',
                        top: '12px',
                        right: '12px',
                        background: '#fff',
                        padding: '4px 12px',
                        borderRadius: '20px',
                        color: '#000',
                        fontSize: '12px',
                        fontWeight: '600',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
                        zIndex: 20
                      }}>
                        {quantityInCart} Added to the Cart
                      </div>
                    )}
                    <div className="mainrelative">
                      <div className="leftRightSpacing" style={{ paddingTop: '15px' }}>
                        <div className="boxHeaderAlignment" style={{ paddingBottom: '10px' }}>
                          <div>
                            <p style={{ marginTop: '15px' }}>{plan.name}</p>
                            <span style={{ display: 'block', minHeight: '42px', lineHeight: '1.3' }}>{plan.description || "Best for personal use."}</span>
                          </div>
                          <h3>${plan.price}</h3>
                        </div>

                        <div className="buttonDesign" style={{ marginBottom: '10px' }}>
                          <button onClick={() => {
                            handleAddToCart(plan);
                          }}>
                            Choose Plan
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M7 7H17V17" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M7 17L17 7" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                        </div>

                        <div className="line" style={{ padding: '2px 0' }}>
                          <svg width="100%" height="2" viewBox="0 0 348 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 1L348 1.00003" stroke="url(#paint0_linear_line)" />
                            <defs>
                              <linearGradient id="paint0_linear_line" x1="0" y1="1.5" x2="348" y2="1.5" gradientUnits="userSpaceOnUse">
                                <stop stopColor="white" stopOpacity="0" />
                                <stop offset="0.5" stopColor="white" stopOpacity="0.5" />
                                <stop offset="1" stopColor="white" stopOpacity="0" />
                              </linearGradient>
                            </defs>
                          </svg>
                        </div>

                        <div className="details">
                          <h4>What you will get</h4>

                          <div className="iconText">
                            <CheckIcon />
                            <span>BUY AT ${plan.price}</span>
                          </div>

                          {/* Hardcoded fields mixed with dynamic features */}
                          {plan.liveAccountLicense && (
                            <div className="iconText">
                              <CheckIcon />
                              <span>{plan.liveAccountLicense} Live Account License</span>
                            </div>
                          )}
                          {plan.accountBalance && (
                            <div className="iconText">
                              <CheckIcon />
                              <span>Account Balance: {plan.accountBalance}</span>
                            </div>
                          )}
                          {plan.validity && (
                            <div className="iconText">
                              <CheckIcon />
                              <span>{plan.validity}</span>
                            </div>
                          )}
                          {plan.martingaleStrategy && (
                            <div className="iconText">
                              <CheckIcon />
                              <span>MARTINGALE STRATEGY</span>
                            </div>
                          )}

                          {/* Existing Dynamic Features (First Part) */}
                          {mainFeatures.map((item, i) => (
                            <div className="iconText" key={i}>
                              <CheckIcon />
                              <span>{item}</span>
                            </div>
                          ))}
                        </div>

                        {/* Referral Section (Bottom) */}
                        <div className="newDetails">
                          <h6>Refer this Plan</h6>
                          <div className="lastTwoWrapper">
                            {referFeatures.length > 0 ? (
                              referFeatures.map((item, i) => (
                                <div className="iconText" key={`last-${i}`}>
                                  <CheckIcon />
                                  <span>{item}</span>
                                </div>
                              ))
                            ) : (
                              // Fallback if no referral features exist
                              <>
                                <div className="iconText">
                                  <CheckIcon />
                                  <span>1 Strategy, 1 Currency Pair</span>
                                </div>
                                <div className="iconText">
                                  <CheckIcon />
                                  <span>Refer a friend and earn bonus</span>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default UserRegistration;
